/** @module MaterialSpec/GenerateColorRuleFromMaterialAvailability **/
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/comm/PostRequest"
], function(declare,lang,Controller,PostRequest) {

return declare(Controller, {
		/**
		 * @override
		 * Query to back end to generate ColorMatching Rules For material
		 */
		process: function() {
			const req = this.m_action.m_request;
			const fd = this.m_formData;
			const availability = this.m_cache.getNode(this.m_urlParent);
			this.setProgress();

			new PostRequest(req.m_module, req.m_operation)
				.addParameter("ParentURL", availability.AvailabilitySeason)
				.addParameter("URL", availability.AvailabilityProduct)
				.addParameter("GenerateFromAvailability", true)
				.post({}).then(lang.hitch(this, this._onPublishResponse));
		}
	});
});